'use client';
import cn from 'classnames';
import style from './ButtonCommon.module.scss';

function ButtonCommon({ className, handleFuction, text, type, testId, mainColor = 'Black' }) {
  const buttonClasses = cn(style[`button${mainColor}`], className);
  return (
    <button className={buttonClasses} onClick={handleFuction} type={!type ? 'button' : type} data-testid={testId}>
      <span>{text}</span>
    </button>
  );
}

export default ButtonCommon;
